import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'
import { getRandom } from '@/utils/index'
import { setSecondRouteList } from '@/utils/common'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/consultant_login', '/test'] // no redirect whitelist
router.afterEach((to, from) => {
  // store.dispatch('router/setFromRouter', from.path)
  const oldPath = store.getters.fromRouterPath
  store.dispatch('router/setFromRouter', to)
  const newPath = store.getters.fromRouterPath
  if (oldPath !== newPath) {
    store.dispatch('app/setCheckLabel', '')
  }
})
router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const isLogin = store.getters.isLogin
  if (isLogin) {
    // 根据用户权限，动态添加路由  TODO，逻辑重构，不好维护
    if (store.getters.isResetPaw === '0') {
      if (to.path !== '/reset') {
        // setSecondRouteList('reset')
        next('/reset')
      } else {
        next()
        NProgress.done()
      }
      return
    }
    if (!store.getters.asyncRoutesAdded) { // 首次和页面刷新
      store.dispatch('router/GenerateRoutes').then(() => { // 生成可访问的路由表
        router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
        if (to.path === '/') {
          // next({ path: '/home', replace: true }) // 查询页面
          next({ path: '/projectManage/meditateProject', replace: true }) // 查询页面
          NProgress.done()
          return
        } else {
          next()
          NProgress.done()
          return
        }
      }, () => {
        console.log('获取目录失败')
      })
    } else { // 跳转页面
      next()
      NProgress.done()
      return
    }
    if (to.path === '/consultant_login' || to.path === '/') {
      // if is logged in, redirect to the home page
      next('/projectManage/meditateProject')
      // next('/home')
      NProgress.done()
    } else {
      next()
      NProgress.done()
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
      NProgress.done()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/consultant_login?redirect=${to.fullPath}`)
      NProgress.done()
    }
  }
})

